import axios from 'axios';

const client = axios.create({
    headers: {
        'Accept': 'application/json, text/html, */*',// makes ure we can accept partials or html for legacy stuff
        'X-Requested-With': 'XMLHttpRequest'
    }
});

const getCsrfToken = () => {
    const tokenTag = document.head.querySelector('meta[name="csrf-token"]');
    return tokenTag ? tokenTag.content : null;
};

const token = getCsrfToken();

if (token) {
    client.defaults.headers.common['X-CSRF-TOKEN'] = token;
} else {
    window.addEventListener('DOMContentLoaded', () => {
        const lateToken = getCsrfToken();
        if (lateToken) {
            client.defaults.headers.common['X-CSRF-TOKEN'] = lateToken;
        } else {
            console.error('CSRF token not found');
        }
    });
}

// Intercept responses to handle errors globally
client.interceptors.response.use(
    response => {
        // Handle the "Full Response" override (for legacy/special cases)
        if (response.config.fullResponse) {
            return response;
        }

        let data = response.data;

        // The "Sloppy JSON" Safety Net
        // If the server sends a string that starts with '{' or '[', it's likely JSON
        // that didn't get the correct Content-Type header from a legacy controller.
        if (typeof data === 'string' && (data.startsWith('{') || data.startsWith('['))) {
            try {
                data = JSON.parse(data);
            } catch (e) {
                // If it fails to parse, it was actually just a string of HTML/text starting with those chars
                // We do nothing and let it stay a string.
            }
        }

        return data;
    },
    error => {
        const { status } = error.response || {};

        if (status === 419) {
            // Laravel Session Expired - Refresh the page to get a new CSRF token
            alert('Your session has expired. The page will now reload.');
            window.location.reload();
        }

        if (status === 401) {
            // Unauthorized - Redirect to login
            window.location.href = '/login';
        }

        if (status >= 500) {
            // Server Error - Log it or show a global notification
            console.error('Backend Error:', error.response.data);
        }

        return Promise.reject(error);
    }
);

window.client = client;

export default client;